// extracted by mini-css-extract-plugin
module.exports = {"social":"Socials_social__BH8Zh"};